import 'react';
import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import withDetectInViewport from '../utils/withDetectInViewport/index.js';
import { jsx } from 'react/jsx-runtime';

const FadeUp = props => {
  const {
    activeCss,
    className,
    children,
    showElement,
    transition
  } = props;
  const activeClass = showElement ? 'active' : '';
  return /*#__PURE__*/jsx(FadeUpBase, {
    activeCss: activeCss,
    className: `${className} ${activeClass}`,
    transition: transition,
    children: children
  });
};
const FadeUpBase = styled.div`
  ${_ref => {
  let {
    transition
  } = _ref;
  return transition;
}}

  transform: translate3d(0, 2rem, 0);
  opacity: 0;

  &.active {
    ${_ref2 => {
  let {
    activeCss
  } = _ref2;
  return activeCss;
}}
  }
`;
FadeUp.defaultProps = {
  activeCss: 'opacity: 1; transform: none;',
  className: '',
  transition: 'transition: transform 500ms cubic-bezier(0.215, 0.61, 0.355, 1) 300ms, opacity 300ms linear 300ms;'
};
FadeUp.propTypes = {
  activeCss: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  showElement: PropTypes.bool.isRequired,
  transition: PropTypes.string
};
var FadeUp$1 = withDetectInViewport(FadeUp);

export { FadeUp$1 as default };
//# sourceMappingURL=FadeUp.js.map
